<script>
  import fileTemplateState from "../../../stores/fileTemplateJsonData"
  import DocDropdown from "../../../../../../Shared/dropDown2.svelte"
  import TemplatesList from "../../../../../../Stores/templatesList"
  import notify from "../../../../../../Script/notify"
  import { push, replace } from "svelte-spa-router"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import DocumentCarousel from "../../../../Documents/List/Stores/documentTemplate"
  // import { checkMaxCharacters, checkSpecialChars, trimSpacesTemplateName } from "../../Script/tempNamevalidation"
  import { trimSpacesTemplateName } from "../../Script/tempNamevalidation"
  import defaultFonts from "../../../stores/fileTemplateDefaultFonts"
  import { loadJs } from "../../../../../../Script/loadLibrary"
  import { loadImage } from "../../Script/loadImg"
  import { onMount } from "svelte"
  import { validateFile } from "../../../../../Publish/BulkUpload/Script/bulkUpload"
  import { getDocumentsList } from "../../../../../Publish/BulkUpload/Script/bulkUpload"
  import axios from "axios"
  import { text } from "svelte/internal"
  import { getRequest, postRequest } from "../../../../../../Script/apiMethods"
  /**
   * @type {Boolean}  to display/hide the base Image modal
   */
  let showModal = true
  /**
   * @type {File}  Object contains the Image Details
   */
  let files = ""
  /**
   * @type {Blob}  blobUrl for the BaseImage
   */
  let blobURL = ""
  /**
   * @type {Number}  baseImage Width
   */
  let width
  /**
   * @type {Number}  baseImage Height
   */
  let height
  /**
   * @type {Boolean}  to show or Not the image loading screen
   */
  let showLoader = false
  /**
   * @type {HTMLElement} - to bind baseImage info name input value
   */
  let focusNameInput
  let closeNotification = {
    close() {},
  }
  /**
   * @type {number} pageNumber
   */
  let page = 1
  /**
   * @type {number} total document count
   */
  let count
  /**
   * @type {number} total pages
   */
  let maxPage
  /**
   * @type {number} starting count of the docList
   */
  let startCount = 1
  /**
   * @type {number} ending count of the docList
   */
  let endCount = 10
  /**
   * @type {boolean} whether to show loading screen or not for dropdown
   */
  let showLoadingForDropDown = false

  /**
   * Performs asynchronous actions on component mount.
   */
  onMount(async () => {
    try {
      showLoadingForDropDown = true
      // Retrieve the list of documents
      let documentList = await getDocumentsList(page)

      count = documentList.count

      maxPage = Math.ceil(count / 10)

      // show document templates by filtering only when they have name
      $TemplatesList.document = documentList.templates.filter((a) => a.name)

      endCount = maxPage == 1 ? count : endCount
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: onMount"
      closeNotification = notify.danger(error, info)
      push("/templates/file")
    } finally {
      showLoadingForDropDown = false
    }
  })

  /**
   * @description Function for display the new base Image
   */
  const addBaseImage = async () => {
    try {
      // Show loading indicator
      showLoader = true
      // Validate the file template name
      if (!$fileTemplateState.baseImageInfo.name.trim()) throw "File template name can't be empty"

      // Load the extract colors script if not already loaded
      await loadJs("extractor", "assets/lib/extract-colors.min.js")
      let clrs = await extractColors(blobURL)

      // Limit the palette to the first 6 colors
      for (let i = 0; i < clrs.length; i++) {
        if (i < 6) {
          $fileTemplateState.baseImageInfo.palette.push(clrs[i].hex)
        }
      }

      // Fetch the selected document template
      const { template: documentData } = await getRequest(`/api/swagger/v2/templates/documents/${$fileTemplateState.documentTemplateId}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      // Parse the document template metadata
      // nested objects - double parse
      $fileTemplateState.parsedJson = JSON.parse(JSON.parse(JSON.stringify(documentData.metadata)))

      $fileTemplateState.parsedJson.url = "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592"
      $fileTemplateState.parsedJson.expireOn = new Date(new Date().setDate(new Date().getDate() + 1)).toDateString().slice(4)
      $fileTemplateState.parsedJson.date = new Date().toDateString().slice(4)
      $fileTemplateState.parsedJson.documentID = "67d4e8f0b3c74621fa9e5b7c"

      $fileTemplateState.parsedJson = { ...$fileTemplateState.parsedJson, Others: "" }

      // Create the new file template object
      let CreateNewFileTemp = {
        name: $fileTemplateState.baseImageInfo.name,
        document: $fileTemplateState.documentTemplateId,
        file: files[0],
        palette: JSON.stringify($fileTemplateState.baseImageInfo.palette),
        quality: $fileTemplateState.baseImageInfo.Quality,
        fonts: JSON.stringify($fileTemplateState.fonts),
        layers: JSON.stringify($fileTemplateState.operations),
      }

      const { template } = await postRequest(`/api/swagger/v2/templates/files`, CreateNewFileTemp, {
        headers: {
          "x-access-token": $ApplicationState.token,
          "Content-Type": "multipart/form-data",
        },
      })

      // Update the base image info with the response data
      $fileTemplateState.baseImageInfo.name = template.name
      $fileTemplateState.baseImageInfo.id = template.id
      $fileTemplateState.baseImageInfo.palette = JSON.parse(template.palette)
      $fileTemplateState.baseImageInfo.uri = template.baseUri
      $fileTemplateState.baseImageInfo.uploadedTime = template.created
      $fileTemplateState.fonts = JSON.parse(template.fonts)
      $fileTemplateState.baseImageInfo.Quality = template.quality
      $fileTemplateState.operations = JSON.parse(template.layers)

      // Assigning baseImageInfo --> width height url uploading time
      $fileTemplateState.baseImageInfo.uploadedTime = files[0].lastModifiedDate
      $fileTemplateState.baseImageInfo.width = width
      $fileTemplateState.baseImageInfo.height = height

      // Save the state to local storage
      localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))

      // Set default fonts
      $defaultFonts.selectedFonts = ["Arial", "Arial Black", "Courier New", "Comic Sans MS", "Times New Roman", "Impact", "Tahoma", "Verdana"]

      // Navigate to the edit template page
      push(`/templates/file/edit?id=${$fileTemplateState.baseImageInfo.id}`)

      $fileTemplateState.showImageSection = true
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: During file template creation"
      closeNotification = notify.danger(error, info)
      // Display error notification and navigate to the templates file page
      push("/templates/file")
    } finally {
      // Hide loading indicator and modals
      showLoader = false
      showModal = false
      $fileTemplateState.baseImageUploadModal = false
    }
  }

  /**
   * @description Function for Converting the range value
   */
  const changeRange = (e) => {
    if (e.target.value > 100) $fileTemplateState.baseImageInfo.rangeValue = 100
    if (e.target.value < 0) $fileTemplateState.baseImageInfo.rangeValue = 0
    if (e.target.type == "number" && e.target.value >= 0 && e.target.value <= 100) $fileTemplateState.baseImageInfo.rangeValue = e.target.value
    // $fileTemplateState.baseImageInfo.Quality = Math.min(1, Math.max(0, Math.round(((15.76935 * $fileTemplateState.baseImageInfo.rangeValue) / 10 / (5.513167 + $fileTemplateState.baseImageInfo.rangeValue / 10)) * 100) / 1000))
    $fileTemplateState.baseImageInfo.Quality = $fileTemplateState.baseImageInfo.rangeValue / 100
  }

  /**
   * @description Function for Fetching the Image details
   */
  const uploadImage = async (e) => {
    //generating blob url

    try {
      if (!e.target.files.length) return
      files = e.target.files
      await validateFile(files[0])
      // Create object URL for the selected file

      // Assigning file size
      const MAX_FILE_SIZE = 2 * 1024 * 1024

      if (MAX_FILE_SIZE < files[0].size) {
        throw "Maximum size Exceeded"
      }
      $fileTemplateState.baseImageInfo.size = files[0].size

      // Load image and get its natural dimensions
      let img = await loadImage(URL.createObjectURL(files[0]))
      height = img.naturalHeight
      width = img.naturalWidth
      // Check image resolution
      if (width < 900 || height < 900) {
        $fileTemplateState.baseImageInfo.size = 0
        throw "Minimum Resolution Should be 900px"
      }
      if ((width >= 900 && width <= 1200) || (height >= 900 && height <= 1200)) {
        closeNotification.close()
        closeNotification = notify.warning("Better resolution of the image should be 1200px")
      }

      blobURL = URL.createObjectURL(files[0])

      // Set focus on the name input field
      focusNameInput.focus()
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: While validating and processing uploaded file"
      closeNotification = notify.danger(error, info)
      files = ""
      blobURL = ""
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
    }
  }

  /**
   * Fetches the next set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchNextTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      $fileTemplateState.documentTempName = e.detail

      // Increment the page count to retrieve the next set of templates
      page++

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      if (page === 1) {
        startCount = page + 10
        if (maxPage === page) endCount = count
        else endCount = 10
      } else {
        startCount = startCount + 10
        if (maxPage === page) endCount = count
        else endCount = startCount + 9
      }

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: While fetching the list of document template on 'Next' button click"
      closeNotification = notify.danger(error, info)
      push("/templates/file")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the previous set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchPreviousTemplates = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      $fileTemplateState.documentTempName = e.detail

      // Decrement the page count to retrieve the previous set of templates
      page--

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = startCount - 10
      endCount = startCount + 9

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: While fetching the list of document template on 'Previous' button click"
      closeNotification = notify.danger(error, info)
      push("/templates/file")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the initial set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchInitialList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      $fileTemplateState.documentTempName = e.detail

      // Increment the page count to retrieve the next set of templates
      page = 1

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = 1
      endCount = 10

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: While fetching the list of document template on 'Move Forward' button click"
      closeNotification = notify.danger(error, info)
      push("/templates/file")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * Fetches the final set of document templates based on a specified count.
   *
   * @param {Event} e - Event object containing details about the trigger.
   */
  const fetchFinalList = async (e) => {
    try {
      // Set the loading state to indicate data fetching
      showLoadingForDropDown = true

      // Store the document name from the event detail
      $fileTemplateState.documentTempName = e.detail

      // Increment the page count to retrieve the next set of templates
      page = maxPage

      // Fetch the list of document templates for the updated page
      let documentList = await getDocumentsList(page)

      // Calculate the updated start and end counts for template display
      startCount = (maxPage - 1) * 10 + 1
      endCount = count

      // Update the TemplatesList with the fetched document templates
      $TemplatesList.document = documentList.templates
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Create template)\nEVENT: While fetching the list of document template on 'Move Last' button click"
      closeNotification = notify.danger(error, info)
      push("/templates/file")
    } finally {
      // Set the loading state to indicate data fetching is complete
      showLoadingForDropDown = false
    }
  }

  /**
   * This function is called when a document's content changes
   */
  const onDocTempChange = async (e) => {
    // assigning the document template id
    $fileTemplateState.documentTemplateId = e.detail
  }

  /**
   * Function for changing the document Template Name
   * @param {CustomEvent} e dispatched value from the component
   */
  const changeDocumentName = async (e) => {
    // assigning the document template name shown in tha dropdown
    $fileTemplateState.documentTempName = e.detail
  }
  let quality = Math.floor($fileTemplateState.baseImageInfo.Quality * 1000) / 10

  /**
   * @type {invalidNotification}
   */
  let invalidNotification = {
    close() {},
  }

  /**
   * Regular expression pattern for allowed characters.
   * Matches any combination of uppercase letters, lowercase letters, digits, spaces, hyphens, parentheses, plus signs, ampersands, and periods.
   * @type {RegExp}
   */
  const allowedCharsRegex = /^[A-Z\d\s-()+&.]*$/i

  const checkSpecialChars = (e, name) => {
    // Close any existing notifications
    const info = "PAGE: File Template Editor (Create template)\nEVENT: Validating invalid characters for the file template name during onBlur/ onPaste/ onKeypress"

    // Destructure the type and key properties from the event object
    let { type, key } = e

    // Check if it's a keypress event and the pressed key is not allowed

    if (type === "keypress" && !allowedCharsRegex.test(key)) {
      invalidNotification.close()

      // Ensure the name property is initialized as a string
      if (typeof $fileTemplateState.baseImageInfo.name !== "string") {
        $fileTemplateState.baseImageInfo.name = "" // Initialize it as an empty string
      }

      // Temporarily append the invalid key
      $fileTemplateState.baseImageInfo.name += key

      // Prevent the default keypress behavior
      e.preventDefault()

      // Show a danger notification
      invalidNotification = notify.danger("Only <strong>Letters</strong>,<strong>Numbers</strong> and <strong>-()+.&</strong> are allowed.", info)
      // invalidNotification = notify.danger("Only &emsp;<br/> <strong>Letters</strong>,&emsp; <br/> <Strong>Numbers</strong> and &emsp; <br/> <strong>-()+.&</strong> are allowed.", info)

      setTimeout(() => {
        // Remove the last invalid character
        $fileTemplateState.baseImageInfo.name = $fileTemplateState.baseImageInfo.name.slice(0, -1)
      }, 100)
    } else if (type === "paste" || type === "blur") {
      invalidNotification.close()

      // Prevent the default paste behavior
      // e.preventDefault()
      let pastedText

      if (type === "blur") {
        pastedText = $fileTemplateState.baseImageInfo.name
      } else {
        // Get the pasted text from the clipboard
        let clipboardData = e.clipboardData || window.clipboardData
        pastedText = clipboardData.getData("text/plain")
      }

      // Set the input value to the pasted text
      name = pastedText

      setTimeout(() => {
        // Remove any characters that are not letters, spaces, or specified special characters
        // let sanitizedText = pastedText.replace(new RegExp(`[^A-Z_\\-\\s\\d()+₹.]`, "gi"), "").trim()
        // Set the input value to the sanitized text
        // name = checkMaxCharacters(name)
        // Show a danger notification indicating the allowed characters and the removed non-specified characters

        if (!allowedCharsRegex.test(pastedText)) {
          let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()
          if (sanitizedText !== pastedText) {
            invalidNotification = notify.danger("Only <strong>Letters</strong>, <Strong>Numbers</strong> and <br/> <strong>-()+.&</strong> are allowed. Removing non-specified Characters", info)
          }
          $fileTemplateState.baseImageInfo.name = sanitizedText
        }

        checkMaxCharacters()
        // $fileTemplateState.baseImageInfo.name = checkMaxCharacters($fileTemplateState.baseImageInfo.name)
        // $fileTemplateState.baseImageInfo.name = name
      }, 500)
    }
  }

  /**
   * @type {Number} - maximum character count for template name
   */
  let maxCharacters = 25

  const checkMaxCharacters = () => {
    //Deleting existing notification
    closeNotification.close()

    // ...
    if ($fileTemplateState.baseImageInfo.name && $fileTemplateState.baseImageInfo.name.length >= maxCharacters) {
      // console.log($fileTemplateState.baseImageInfo.name.length, "name")

      // Displaying notification for exceeding maximum characters
      closeNotification = notify.info(`Template name should not be more than ${maxCharacters} characters`)

      // Setting a timer to slice the name to maxCharacters
      setTimeout(() => {
        $fileTemplateState.baseImageInfo.name = $fileTemplateState.baseImageInfo.name.slice(0, maxCharacters)
      }, 20)
    }
  }
</script>

<div class="fixed inset-0 z-20 overflow-y-auto rounded-md bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="flex h-full flex-col items-center justify-center p-10">
    <div class="w-[400px]">
      <div class="flex w-full flex-col gap-6 rounded-t-md bg-darkgray p-6 text-[#A7A7A7]">
        <!-- {#if showLoader} -->
        <!-- {:else} -->
        <span class="text-center text-xl font-bold">Creating a New File Design</span>
        <!-- <p class="text-base">If you have a image from your system upload using below option</p> -->
        {#if blobURL}
          <div class="flex gap-3">
            <div class="group relative flex w-1/2 items-center justify-center">
              <div class="absolute inset-0 hidden items-center justify-center gap-3 rounded-md bg-[#000000cc] group-hover:flex">
                <button
                  on:click={() => {
                    blobURL = ""
                  }}
                  class="flex cursor-pointer select-none items-center justify-center rounded-full border border-transparent text-xl font-medium text-gray-300 hover:text-red-600 focus:outline-none active:text-red-900"
                >
                  <i class="fa-solid fa-circle-xmark" />
                </button>
              </div>
              <img src={blobURL} alt="uploaded_image" class="aspect-auto max-h-[116px] max-w-full rounded-md" id="img" />
            </div>
            <div class="space-y-3 font-light">
              <p class="w-44 truncate font-semibold">{files[0].name}</p>
              <p>{Math.round(files[0].size / 1024)} KB</p>
              <p>{width ? width : 0} x {height ? height : 0}</p>
            </div>
          </div>
        {:else}
          <div class="relative flex cursor-pointer flex-col items-center gap-2 rounded-md border-dashed bg-blue-500 p-5 text-white hover:bg-blue-600">
            <input type="file" class="absolute inset-0 cursor-pointer opacity-0" on:input={uploadImage} accept="image/*" />
            <span class="py-1">
              <i class="fa-solid fa-cloud-arrow-up fa-xl" />
            </span>
            <p class="text-center text-base font-light">Select a file by dragging and dropping it, or Click here to upload.</p>
            <p class="text-sm font-light">Maximum Size 2MB</p>
            <p class="text-sm font-light">Minimum screen dimensions: 900px x 900px.</p>
            <p class="text-sm font-light">Supported formats: jpg, jpeg, png.</p>
          </div>
        {/if}
        {#if $fileTemplateState.baseImageInfo.size}
          <div class="group relative w-full rounded-md">
            <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {$fileTemplateState.baseImageInfo.name ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">NAME</div>
            <!-- // $fileTemplateState.baseImageInfo.name = checkSpecialChars(e, $fileTemplateState.baseImageInfo.name)
            // checkSpecialChars(e, $fileTemplateState.baseImageInfo.name) -->
            <!-- on:keypress={(e) => {
              // $fileTemplateState.baseImageInfo.name = checkSpecialChars(e, $fileTemplateState.baseImageInfo.name)
              checkSpecialChars(e, $fileTemplateState.baseImageInfo.name)
            }} -->
            <input
              required
              on:blur={() => {
                $fileTemplateState.baseImageInfo.name = trimSpacesTemplateName($fileTemplateState.baseImageInfo.name)
              }}
              on:blur={checkSpecialChars}
              on:paste={checkSpecialChars}
              on:keypress={checkSpecialChars}
              on:keypress={checkMaxCharacters}
              bind:value={$fileTemplateState.baseImageInfo.name}
              type="text"
              bind:this={focusNameInput}
              placeholder="Enter template name"
              class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none invalid:animate-shake invalid:border-red-500 focus:ring-2 focus:ring-extraBlue-500 focus:invalid:ring-red-500"
            />
          </div>
        {/if}
        {#if $fileTemplateState.baseImageInfo.size && $fileTemplateState.baseImageInfo.name}
          <div class="flex flex-col gap-2">
            <span>Select Document Template</span>

            <DocDropdown temp="File" on:moveLast={fetchFinalList} on:moveFirst={fetchInitialList} bind:showLoading={showLoadingForDropDown} on:selectedName={changeDocumentName} selectedName={$fileTemplateState.documentTempName} on:itemSelect={onDocTempChange} on:fetchNext={fetchNextTemplates} on:fetchPrevious={fetchPreviousTemplates} {startCount} {endCount} {maxPage} {page} {count} selected={$fileTemplateState.documentTemplateId || "Choose a Document template"} dropdownItems={$TemplatesList.document} />
          </div>
        {/if}
        {#if $fileTemplateState.baseImageInfo.size && $fileTemplateState.baseImageInfo.name && ($fileTemplateState.documentTemplateId || $DocumentCarousel.template.name)}
          <div class="flex flex-col gap-3">
            <span>Quality to download file.</span>
            <div class="flex items-center gap-3 text-gray-g00">
              <input on:input={changeRange} min="0" max="100" bind:value={$fileTemplateState.baseImageInfo.rangeValue} type="number" class="w-12 rounded-md border border-stone-700 bg-transparent py-2 pl-2 pr-1 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500 peer-focus:ring-2 peer-focus:ring-extraBlue-500" />
              <!-- <div class="w-12 rounded-md border border-[#a0a1a580] px-2 py-0.5 text-xs text-white">
                {Math.floor($fileTemplateState.baseImageInfo.Quality * 1000) / 10}
              </div> -->
              <input
                on:wheel|preventDefault|stopPropagation={(e) => {
                  if (e.deltaY < 0) {
                    if ($fileTemplateState.baseImageInfo.rangeValue < 100) {
                      $fileTemplateState.baseImageInfo.rangeValue += 1
                      // $fileTemplateState.baseImageInfo.Quality = Math.min(1, Math.max(0, Math.round(((15.76935 * $fileTemplateState.baseImageInfo.rangeValue) / 10 / (5.513167 + $fileTemplateState.baseImageInfo.rangeValue / 10)) * 100) / 1000))
                      $fileTemplateState.baseImageInfo.Quality = $fileTemplateState.baseImageInfo.rangeValue / 100
                    }
                  } else {
                    if ($fileTemplateState.baseImageInfo.rangeValue > 0) {
                      $fileTemplateState.baseImageInfo.rangeValue -= 1
                      // $fileTemplateState.baseImageInfo.Quality = Math.min(1, Math.max(0, Math.round(((15.76935 * $fileTemplateState.baseImageInfo.rangeValue) / 10 / (5.513167 + $fileTemplateState.baseImageInfo.rangeValue / 10)) * 100) / 1000))
                      $fileTemplateState.baseImageInfo.Quality = $fileTemplateState.baseImageInfo.rangeValue / 100
                    }
                  }
                }}
                bind:value={$fileTemplateState.baseImageInfo.rangeValue}
                title={Math.floor($fileTemplateState.baseImageInfo.Quality * 1000) / 10}
                step="1"
                on:input={changeRange}
                min="1"
                max="100"
                type="range"
                class="w-full"
              />
            </div>
          </div>
        {/if}
      </div>
      <div class="flex w-full justify-between rounded-b-md bg-[#242424] p-6 text-[#A7A7A7]">
        <button
          type="button"
          on:click={() => {
            showModal = false
            push("/templates/file")
          }}
          class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none"
        >
          <span class="text-white">
            <i class="fa-solid fa-circle-xmark" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Close</span>
        </button>
        <button disabled={!blobURL || !$fileTemplateState.baseImageInfo.name || !$fileTemplateState.documentTemplateId || showLoader} on:click={addBaseImage} class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30">
          <span class="text-white">
            <i class="fa-solid fa-pen-to-square" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Create</span>
        </button>
      </div>
    </div>
  </div>
</div>

{#if showLoader}
  <div class="fixed inset-0 z-30 flex items-center justify-center backdrop-blur-md">
    <div class="h-20 w-20 animate-spin rounded-full border-[3px] border-slate-300 border-r-blue-500" />
  </div>
{/if}

<style>
  input[type="range"] {
    height: 4px;
    border-radius: 6px;
    cursor: pointer;
    background-color: (#1b5fda);
  }

  input[type="range"]::-webkit-slider-thumb {
    height: 12px;
    width: 12px;
    border-radius: 100%;
    background: #1b5fda;
  }
</style>
